<template>
    <section>
        <modal  v-if="showModalRelateCode" @close="showModalRelateCode = false"
                v-on:keydown.esc="showModal = false"
                title="Relacionar clave Inegi"
                :sizeOfModal="'large'"
                :allowScrolling="true"
                :showElement="showModalRelateCode">
            <template v-slot:modalContent>
                <sui-table celled>
                    <sui-table-header>
                        <sui-table-row>
                            <sui-table-header-cell>Localidad: {{ location.colony }}</sui-table-header-cell>
                            <sui-table-header-cell>Tipo: {{ location.colony_type }}</sui-table-header-cell>
                            <sui-table-header-cell>Ciudad: {{ location.city }}</sui-table-header-cell>
                            <sui-table-header-cell>Municipio: {{ location.location_name }}</sui-table-header-cell>
                            <sui-table-header-cell>Tipo zona: {{ location.zone_type }}</sui-table-header-cell>
                        </sui-table-row>
                    </sui-table-header>
                </sui-table>
                <div style="max-height: 600px;">
                    <sui-form @submit.prevent="">
                        <sui-form-fields fields="two">
                            <sui-form-field width='twelve' required>
                                <label>Escribe una abreviación de la localidad</label>
                                <input type="text" v-model="record.locationName"/>
                            </sui-form-field>
                            <sui-form-field>
                                <br>
                                <sui-button primary floated="right" @click="searchLocation()">Buscar</sui-button>
                            </sui-form-field>
                        </sui-form-fields>
                    </sui-form>
                    Catálogo INEGI
                    <sui-table fixed compact="very">
                        <sui-table-header>
                            <sui-table-row>
                                <sui-table-header-cell class="txtc">Clave</sui-table-header-cell>
                                <sui-table-header-cell class="txtc">Localidad</sui-table-header-cell>
                                <sui-table-header-cell class="txtc">Ambito</sui-table-header-cell>
                                <sui-table-header-cell class="txtc">Población</sui-table-header-cell>
                                <sui-table-header-cell class="txtc">Viviendas</sui-table-header-cell>
                                <sui-table-header-cell class="txtc"></sui-table-header-cell>
                            </sui-table-row>
                        </sui-table-header>
                        <sui-table-body style="height:80%;overflow-y: scroll;">
                            <sui-table-row v-for="locationInegi of inegiLocations" :key="locationInegi.cvegeo">
                                <sui-table-cell class="txtc">{{ locationInegi.cvegeo }}</sui-table-cell>
                                <sui-table-cell class="txtc">{{ locationInegi.nom_loc }}</sui-table-cell>
                                <sui-table-cell class="txtc">{{ locationInegi.ambito }}</sui-table-cell>
                                <sui-table-cell class="txtc">{{ locationInegi.pob }}</sui-table-cell>
                                <sui-table-cell class="txtc">{{ locationInegi.viv }}</sui-table-cell>
                                <sui-table-cell class="txtc" :width="1">
                                    <sui-button class="ui left floated button" @click="relateCode(locationInegi.cvegeo)" size="mini" color="blue">Relacionar</sui-button>
                                </sui-table-cell>
                            </sui-table-row>
                        </sui-table-body>
                    </sui-table>
                </div>
            </template>
            <template v-slot:modalFooter>
                <div class="actions">
                    <sui-button negative @click="close(true)">Cancelar</sui-button>
                </div>
            </template>
        </modal>
    </section>
</template>
<script>

import Modal from '@/components/Helpers/Modal.vue'
import Utils from '@/common/Utils.js'
import LocationsService from '@/services/LocationsService'

export default {
    name: 'RelateInegiCode',
    components: { Modal },
    props: {
        showModalRelateCode: {
            type: Boolean, default: () => false
        },
        location: {
            type: Object, default: () => {}
        }
    },
    data () {
        return {
            Utils: Utils,
            record: {
                locationName: '',
                stateCode: '',
                municipalityCode: ''
            },
            inegiLocations: []
        }
    },
    mounted () {
        this.record.locationName = this.location.colony_name
    },
    methods: {
        close () {
            this.record = {
                locationName: '',
                stateCode: '',
                municipalityCode: ''
            }
            this.inegiLocations = []
            this.showModalRelateCode = false
            this.$emit('modalResponse', location)
        },
        async searchLocation () {
            if (this.record.hasOwnProperty('locationName')) {
                this.record.stateCode = this.location.state_code
                this.record.municipalityCode = this.location.municipality_code
                let response = await LocationsService.searchLocation(this.record)
                if (response) {
                    this.inegiLocations = response.data
                }
            } else {
                this.$swal({
                    title: 'Atención',
                    html: 'Favor escribir el nombre de la localidad'
                })
            }
        },
        async relateCode (cvegeo) {
            this.$swal({
                title: '¿Deseas relacionar este código a la localidad?',
                html: '',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                showCloseButton: false,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.value === true) {
                    this.loader = this.$loading.show()
                    let response = await LocationsService.relateInegiCode(this.location, cvegeo)
                    this.loader.hide()
                    if (response.status === 'success') {
                        let updatedRecord = {
                            colonyId: this.location.colony_id
                        }
                        this.record = {
                            locationName: '',
                            stateCode: '',
                            municipalityCode: ''
                        }
                        this.inegiLocations = []
                        this.showModalRelateCode = false
                        this.$emit('modalResponse', updatedRecord)
                    }
                }
            })
        }
    }
}
</script>
